import React, { createContext, useCallback, useContext, useState } from 'react';
import { ReactChildren } from './DoneeProvider';

export const PaymentOutageContext = createContext<{
  open: boolean;
  handleOpen: () => unknown;
  handleClose: () => unknown;
}>({
  open: false,
  handleOpen: () => null,
  handleClose: () => null
});

export const usePaymentOutageContext = () => useContext(PaymentOutageContext);

const PaymentOutageProvider: React.FC<ReactChildren> = ({ children }) => {
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <PaymentOutageContext.Provider
      value={{
        open,
        handleOpen,
        handleClose
      }}
    >
      {children}
    </PaymentOutageContext.Provider>
  );
};

export default PaymentOutageProvider;
